import IBBillsGrid from "./Grid";
import Footer from "../../components/Footer";
import CancelButton from "../../components/Buttons/CancelButton";
import NextOrCompleteButton from "../../components/Buttons/NextOrCompleteButton";
import BackButton from "../../components/Buttons/BackButton";
import { redirectToIBPlanning } from "../../utils";
import { useNavigate } from "react-router-dom"
import { withStyles } from "@material-ui/core";

const styles = (theme) => ({
  actionButton: {
    '&$disabledButton': {
      backgroundColor: theme.customInputBGColor,
      color: theme.TextColor,
      cursor: "not-allowed",
      opacity: 0.8,
    },
  },
  disabledButton: {},
});


const IBBill = ({
  data,
  glEventHub,
  userProfile,
  showDueBills,
  goBack,
  handleNext,
  isLastStep,
  onIBCutoffChanged,
  ibEtaCutOff,
  gridErrorMessage,
  toggleValue,
  handleToggleClick,
  isShipmentSelectionCompleted,
  classes,
  ...otherProps
}) => {
  const navigate = useNavigate();
  const disableActionButton = !data || isShipmentSelectionCompleted;
  return (
    <>
      <IBBillsGrid
        rowData={data}
        glEventHub={glEventHub}
        userProfile={userProfile}
        showDueBills={showDueBills}
        onIBCutoffChanged={onIBCutoffChanged}
        ibEtaCutOff={ibEtaCutOff}
        gridErrorMessage={gridErrorMessage}
        toggleValue={toggleValue}
        handleToggleClick= {handleToggleClick} 
        {...otherProps}
      />
      <Footer>
        <CancelButton onClick={redirectToIBPlanning(navigate)} />
        <BackButton onClick={goBack} disabled={disableActionButton} />
        <NextOrCompleteButton onClick={handleNext} disabled={disableActionButton} isLastStep={isLastStep} />
      </Footer>
    </>
  );
};

export default withStyles(styles)(IBBill);
